import { useCallback } from "react";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";

export default function SideBar({ isSidebarOpen, setIsSidebarOpen }) {
  const { associationId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const activeLinkStyle = {
    // backgroundColor: '#c4281b',
    backgroundColor: "#c4281bc4",
    borderLeft: "3px solid #000",
  };

  const activeLink = {
    color: "#ffffff",
  };

  const storedPermissions = localStorage.getItem("userPermissions");
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  // console.log(permissions, 666);

  // Define the hasPermission function
  const hasPermission = (permission) => {
    return Array.isArray(permissions) && permissions.includes(permission);
  };

  // Use useCallback to memoize the function
  const handleLinkClick = useCallback(
    (to) => {
      return (e) => {
        if (window.matchMedia("(max-width: 768px)").matches) {
          e.preventDefault();
          setIsSidebarOpen(false);
          navigate(to);
        }
      };
    },
    [setIsSidebarOpen, navigate]
  );

  return (
    // <!-- ========== App Menu ========== -->
    <div
      className={`app-menu navbar-menu ${isSidebarOpen ? "sidebar-open" : "sidebar-close"
        }`}
    >
      {/* <!-- LOGO --> */}
      <div className={`navbar-brand-box ${isSidebarOpen ? "" : "logo-hidden"}`}>
        {/* <!-- Dark Logo--> */}
        <Link to="/" className="logo logo-dark">
          <span className="logo-sm">
            <img src="/assets/JF-Inspired.png" alt="" height="22" />
          </span>
          <span className="logo-lg">
            <img src="/assets/JF-Inspired.png" alt="" height="40" />
          </span>
        </Link>
        {/* <!-- Light Logo--> */}
        <Link to="/" className="logo logo-light">
          <span className="logo-sm">
            <img src="/assets/JF-Inspired.png" alt="" height="50" />
          </span>
          <span className="logo-lg">
            <img src="/assets/JF-Inspired.png" alt="" height="100" />
          </span>
        </Link>
        <button
          type="button"
          className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
          id="vertical-hover"
        >
          <i className="ri-record-circle-line"></i>
        </button>
      </div>

      <div id="scrollbar">
        <div className="container-fluid">
          <button
            className="close-sidebar"
            onClick={(prevState) => setIsSidebarOpen(!prevState)}
          >
            <span className="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <ul className="navbar-nav" id="navbar-nav">
            {hasPermission("view_dashboard") && (
              <li
                style={
                  location.pathname === "/app/dashboard" ? activeLinkStyle : {}
                }
                className="nav-item"
              >
                <Link
                  className="nav-link menu-link"
                  to="/app/dashboard"
                  onClick={handleLinkClick("/app/dashboard")}
                >
                  <i
                    className="ri-bar-chart-line"
                    style={
                      location.pathname === "/app/dashboard" ? activeLink : {}
                    }
                  ></i>
                  <div className="text-center">
                    <span
                      data-key="t-dashboards"
                      style={
                        location.pathname === "/app/dashboard" ? activeLink : {}
                      }
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      <span style={{ fontSize: "14px" }}>Dashboard</span>
                    </span>
                  </div>
                </Link>
              </li>
            )}

            {hasPermission("roles_and_permissions") && (
              <li
                style={location.pathname === "/app/acl" ? activeLinkStyle : {}}
                className="nav-item"
              >
                <Link
                  className="nav-link menu-link"
                  to="/app/acl"
                  onClick={handleLinkClick("/app/acl")}
                >
                  <i
                    className="ri-settings-2-line"
                    style={location.pathname === "/app/acl" ? activeLink : {}}
                  ></i>
                  <div className="text-center">
                    <span
                      data-key="t-dashboards"
                      style={location.pathname === "/app/acl" ? activeLink : {}}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      <span style={{ fontSize: "14px" }}>
                        User Access Level
                      </span>
                    </span>
                  </div>
                </Link>
              </li>
            )}
            {hasPermission("view_customer") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sidebarIcons"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="true"
                  aria-controls="sidebarIcons"
                >
                  <i className="ri-group-line"></i>
                  <div>
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Customer Management
                    </span>
                  </div>
                </Link>
                {/* company_details */}
                <div className="collapse menu-dropdown" id="sidebarIcons">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/customer"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/customer"
                        onClick={handleLinkClick("/app/customer")}
                      >
                        <i
                          className="ri-user-2-line"
                          style={
                            location.pathname === "/app/customer"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/customer"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Customer{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="collapse menu-dropdown" id="sidebarIcons">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/company_details"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/company_details"
                        onClick={handleLinkClick("/app/company_details")}
                      >
                        <i
                          className="ri-information-line"
                          style={
                            location.pathname === "/app/company_details"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/company_details"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Company Details{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {hasPermission("view_product") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sidebProducts"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebProducts"
                >
                  <i className="ri-store-line"></i>
                  <div className="">
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Product Management
                    </span>
                  </div>
                </Link>
                <div className="collapse menu-dropdown" id="sidebProducts">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/manage-category"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/manage-category"
                        onClick={handleLinkClick("/app/manage-category")}
                      >
                        <i
                          className="ri-focus-3-fill"
                          style={
                            location.pathname === "/app/manage-category"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/manage-category"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Category{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="collapse menu-dropdown" id="sidebProducts">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/group-simplecode"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/group-simplecode"
                        onClick={handleLinkClick("/app/group-simplecode")}
                      >
                        <i
                          className="ri-focus-3-fill"
                          style={
                            location.pathname === "/app/group-simplecode"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/group-simplecode"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Simple Code{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="collapse menu-dropdown" id="sidebProducts">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/product-management"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/product-management"
                        onClick={handleLinkClick("/app/product-management")}
                      >
                        <i
                          className="ri-store-2-fill"
                          style={
                            location.pathname === "/app/product-management"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/product-management"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Products{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}

            <li className="nav-title">
              <Link
                className="nav-link menu-link"
                to="#sidebankaccount"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sidebankaccount"
              >
                <i className="ri-wallet-line"></i>
                <div className="">
                  <span
                    data-key="t-icons"
                    style={{ opacity: "0.5", fontSize: "14px" }}
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Bank Account
                  </span>
                </div>
              </Link>
              <div className="collapse menu-dropdown" id="sidebankaccount">
                <ul className="nav nav-sm flex-column">
                  <li
                    className="nav-item"
                    style={
                      location.pathname === "/app/bank-accounts"
                        ? activeLinkStyle
                        : {}
                    }
                  >
                    <Link
                      className="nav-link"
                      data-key="t-remix"
                      to="/app/bank-accounts"
                      onClick={handleLinkClick("/app/bank-accounts")}
                    >
                      <i
                        className="ri-wallet-line"
                        style={
                          location.pathname === "/app/bank-accounts"
                            ? activeLink
                            : {}
                        }
                      ></i>
                      <span
                        data-key="t-widgets"
                        style={
                          location.pathname === "/app/bank-accounts"
                            ? activeLink
                            : {}
                        }
                        className={`${isSidebarOpen ? "show" : "hidden"}`}
                      >
                        Bank Account{" "}
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
            {hasPermission("view_order") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sideOrder"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sideOrder"
                >
                  <i className="ri-file-list-line"></i>
                  <div className="">
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Order Management
                    </span>
                  </div>
                </Link>
                <div className="collapse menu-dropdown" id="sideOrder">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/order-management"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/order-management"
                        onClick={handleLinkClick("/app/order-management")}
                      >
                        <i
                          className="ri-file-list-line"
                          style={
                            location.pathname === "/app/order-management"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/order-management"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Manage Order{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                {hasPermission("approve_order") && (
                  <div className="collapse menu-dropdown" id="sideOrder">
                    <ul className="nav nav-sm flex-column">
                      <li
                        className="nav-item"
                        style={
                          location.pathname === "/app/order-approval"
                            ? activeLinkStyle
                            : {}
                        }
                      >
                        <Link
                          className="nav-link"
                          data-key="t-remix"
                          to="/app/order-approval"
                          onClick={handleLinkClick("/app/order-approval")}
                        >
                          <i
                            className="ri-task-line"
                            style={
                              location.pathname === "/app/order-approval"
                                ? activeLink
                                : {}
                            }
                          ></i>
                          <span
                            data-key="t-widgets"
                            style={
                              location.pathname === "/app/order-approval"
                                ? activeLink
                                : {}
                            }
                            className={`${isSidebarOpen ? "show" : "hidden"}`}
                          >
                            Order approval{" "}
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            )}

            <li className="nav-title">
              <Link
                className="nav-link menu-link"
                to="#sideCredit"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="sideCredit"
              >
                <i className="ri-wallet-line"></i>
                <div className="">
                  <span
                    data-key="t-icons"
                    style={{ opacity: "0.5", fontSize: "14px" }}
                    className={`${isSidebarOpen ? "show" : "hidden"}`}
                  >
                    Credit Management
                  </span>
                </div>
              </Link>
              <div className="collapse menu-dropdown" id="sideCredit">
                <ul className="nav nav-sm flex-column">
                  <li
                    className="nav-item"
                    style={
                      location.pathname === "/app/credit" ? activeLinkStyle : {}
                    }
                  >
                    <Link
                      className="nav-link"
                      data-key="t-remix"
                      to="/app/credit"
                      onClick={handleLinkClick("/app/credit")}
                    >
                      <i
                        className="ri-wallet-line"
                        style={
                          location.pathname === "/app/credit" ? activeLink : {}
                        }
                      ></i>
                      <span
                        data-key="t-widgets"
                        style={
                          location.pathname === "/app/credit" ? activeLink : {}
                        }
                        className={`${isSidebarOpen ? "show" : "hidden"}`}
                      >
                        Credit Management{" "}
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {hasPermission("view_requisition") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sideRequisition"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sideRequisition"
                >
                  <i className="ri-task-line"></i>
                  <div className="">
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Requisition Management
                    </span>
                  </div>
                </Link>
                <div className="collapse menu-dropdown" id="sideRequisition">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/check-out"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/check-out"
                        onClick={handleLinkClick("/app/check-out")}
                      >
                        <i
                          className="ri-task-line"
                          style={
                            location.pathname === "/app/check-out"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/check-out"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Outbound Orders{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}

            {hasPermission("view_payment_order") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sideOrderApproval"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sideOrderApproval"
                >
                  <i className="ri-task-line"></i>
                  <div className="">
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Payment Management
                    </span>
                  </div>
                </Link>
                <div className="collapse menu-dropdown" id="sideOrderApproval">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/payment"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/payment"
                        onClick={handleLinkClick("/app/payment")}
                      >
                        <i
                          className="ri-task-line"
                          style={
                            location.pathname === "/app/payment"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/payment"
                              ? activeLink
                              : {}
                          }
                        >
                          Payment Orders{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}

            {hasPermission("view_inventory") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sideInventory"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sideInventory"
                >
                  <i className="ri-database-2-line"></i>
                  <div className="">
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                      className={`${isSidebarOpen ? "show" : "hidden"}`}
                    >
                      Inventory Management
                    </span>
                  </div>
                </Link>
                <div className="collapse menu-dropdown" id="sideInventory">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/manage-warehouse"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/manage-warehouse"
                        onClick={handleLinkClick("/app/manage-warehouse")}
                      >
                        <i
                          className="ri-building-line"
                          style={
                            location.pathname === "/app/manage-warehouse"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/manage-warehouse"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Manage Warehouse{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="collapse menu-dropdown" id="sideInventory">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/check-in"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/check-in"
                        onClick={handleLinkClick("/app/check-in")}
                      >
                        <i
                          className="ri-add-circle-line"
                          style={
                            location.pathname === "/app/check-in"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/check-in"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Inbound{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="collapse menu-dropdown" id="sideInventory">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/transfer"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/transfer"
                        onClick={handleLinkClick("/app/transfer")}
                      >
                        <i
                          className="ri-exchange-line"
                          style={
                            location.pathname === "/app/transfer"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/transfer"
                              ? activeLink
                              : {}
                          }
                          className={`${isSidebarOpen ? "show" : "hidden"}`}
                        >
                          Transfer{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>

              </li>
            )}
            {/* {hasPermission("view_report") && (
              <li className="nav-title">
                <Link
                  className="nav-link menu-link"
                  to="#sideReport"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sideReport"
                >
                  <i className="ri-file-chart-line"></i>
                  <div className="">
                    <span
                      data-key="t-icons"
                      style={{ opacity: "0.5", fontSize: "14px" }}
                    >
                      Report
                    </span>
                  </div>
                </Link>
                <div className="collapse menu-dropdown" id="sideReport">
                  <ul className="nav nav-sm flex-column">
                    <li
                      className="nav-item"
                      style={
                        location.pathname === "/app/report"
                          ? activeLinkStyle
                          : {}
                      }
                    >
                      <Link
                        className="nav-link"
                        data-key="t-remix"
                        to="/app/report"
                      >
                        <i
                          className="ri-file-chart-line"
                          style={
                            location.pathname === "/app/report"
                              ? activeLink
                              : {}
                          }
                        ></i>
                        <span
                          data-key="t-widgets"
                          style={
                            location.pathname === "/app/report"
                              ? activeLink
                              : {}
                          }
                        >
                          Report{" "}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )} */}
          </ul>
        </div>
        {/* <!-- Sidebar --> */}
      </div>

      <div className="sidebar-background"></div>
    </div>
  );
}
